import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import arrowDown from "../../assets/images/downArrow.svg";
import arrowUp from "../../assets/images/upArrow.svg";
import { useGetUserInformation } from "../../features/users";

const NavbarItems = ({ sidebaritems, type }) => {
  const { data: user } = useGetUserInformation();
  const isMarketer = user?.is_marketer;

  const navigate = useNavigate();
  const location = useLocation();
  const userFirstName = user?.first_name_fa || "";
  const userLastName = user?.last_name_fa || "";
  const businessName = useSelector((store) => store.bussinessSlice?.data.business?.fa_name || "");

  const [activeMenu, setActiveMenu] = useState(null);
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);

  useEffect(() => {
    setActiveMenu(null);
    sidebaritems.forEach((nav, index) => {
      if (location.pathname.startsWith(nav.path)) {
        setActiveMenu(index);
        nav.subNav.forEach((sub) => {
          const fullPath = nav.path + sub.path;
          if (location.pathname === fullPath) {
            setSelectedSubMenu(fullPath);
          }
        });
      }
    });
  }, [location.pathname, sidebaritems]);

  const menuClickHandler = (index, nav) => {
    setActiveMenu(index);
    if (!nav.subNav.length) {
      navigate(nav.path);
      setSelectedSubMenu(nav.path);
    } else {
      const fullPath = nav.path + nav.subNav[0].path;
      navigate(fullPath);
      setSelectedSubMenu(fullPath);
    }
  };

  const subMenuClickHandler = (navPath, subPath) => {
    const fullPath = navPath + subPath;
    navigate(fullPath);
    setSelectedSubMenu(fullPath);
  };

  return (
    <div className="min-w-[240px] text-title-sm-regular bg-neutral-10 h-fit     flex flex-col ">
      {type === "business" && (
        // <Link to={`bussiness/detail`} className=" text-title-md-semibold " >
        <Link className=" text-title-md-semibold max-w-[200px] truncate p-2 mb-2 ">{businessName}</Link>
      )}
      {sidebaritems.map((nav, index) => {
        const disableMarketing = nav.path === "/marketing" && !isMarketer;

        const isActive = activeMenu === index;
        // Determine if the current item is the neighbor of the active one.
        const isAfterActive = index === activeMenu + 1;
        const isBeforeActive = index === activeMenu - 1;

        // For active items we might want the container to have its own rounding.
        // (Adjust as needed—you might want the active item to appear flush with its neighbors.)
        let activeClasses = "";
        if (isActive) {
          if (index === 0) {
            activeClasses = "rounded-tl-xl";
          } else if (index === sidebaritems.length - 1) {
            activeClasses = "rounded-bl-xl";
          } else {
            // Optionally, if you want the active middle item to be rounded on both sides:
            activeClasses = "rounded-xl";
          }
        }

        // For non-active items, if they are immediately adjacent to the active item add rounding.
        let neighborClasses = "";
        if (!isActive) {
          if (activeMenu === 0 && isAfterActive) {
            // If first item is active, add top rounding to the second item.
            neighborClasses = "rounded-tl-xl";
          } else if (activeMenu === sidebaritems.length - 1 && isBeforeActive) {
            // If last item is active, add bottom rounding to the item before last.
            neighborClasses = "rounded-bl-xl";
          } else if (activeMenu > 0 && activeMenu < sidebaritems.length - 1) {
            if (isAfterActive) neighborClasses = "rounded-tl-xl";
            if (isBeforeActive) neighborClasses = "rounded-bl-xl";
          }
        }

        // For non-active items that are not adjacent, you may want a default border.
        const defaultBorder = !isActive && !neighborClasses ? "" : "";
        return (
          <div key={index} className="flex flex-col w-full mx-auto ">
            <div
              className={` ${disableMarketing ? "hidden" : "flex"} justify-between py-4 px-1 hover:bg-primary-40 cursor-pointer  ${
                isActive ? "bg-neutral-10" : "bg-white"
              } ${isActive ? activeClasses : ""} ${
                !isActive ? defaultBorder : ""
              } ${!isActive ? neighborClasses : ""}`}
              onClick={() => menuClickHandler(index, nav)}
              aria-expanded={isActive}
              aria-controls={`submenu-${index}`}
            >
              <div className={isActive ? "text-title-md-semibold  flex-col " : " flex-col "}>
                <div className="flex gap-2">
                  {nav.icon ? <img width={16} height={16} src={nav?.icon} alt="*" /> : null}
                  <p> {nav?.title}</p>
                </div>
                {type === "user" && index === 0 && (
                  <p className=" text-title-sm-regular max-w-[200px] truncate ">
                    {userFirstName + " " + userLastName}
                  </p>
                )}
              </div>
              {nav.subNav.length !== 0 ? (
                <img src={isActive ? arrowUp : arrowDown} alt="" width={16} height={16} />
              ) : null}
            </div>

            {isActive && (
              <div id={`submenu-${index}`} className="  bg-neutral-10">
                {nav.subNav.map((sub, subIndex) => {
                  const isSelected = selectedSubMenu === nav.path + sub.path;
                  return (
                    <div
                      key={subIndex}
                      onClick={() => subMenuClickHandler(nav.path, sub.path)}
                      className={`flex  items-center gap-2 p-1 pr-3 rounded-xl   cursor-pointer  ${
                        isSelected ? "bg-primary-100 text-white hover:bg-primary-100" : "hover:bg-primary-50"
                      }`}
                      aria-selected={isSelected}
                    >
                      {sub.icon ? (
                        <img style={{ stroke: "white" }} width={16} height={16} src={sub.icon} alt="*" />
                      ) : null}
                      <p>{sub.title}</p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NavbarItems;
